import { render, staticRenderFns } from "./PublicStatistics.vue?vue&type=template&id=79d76922&"
import script from "./PublicStatistics.vue?vue&type=script&lang=js&"
export * from "./PublicStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports